import React, {Component} from 'react';
import {getOneLoggerAdsModal} from './../../modules/Api'
import {Card, Row, Col, Icon} from 'antd'
import {Chart} from 'react-google-charts'

const MyChart = (props) => {
    return (
        <Chart
            width={'100%'}
            height={'300px'}
            chartType="AreaChart"
            loader={<Icon type="loading" style={{ fontSize: 35, textAlign: 'center', marginTop: 100, width: '100%' }} spin />}
            data={props.data}
            options={{
            annotations: {
                boxStyle: {
                    margin: 'auto',
                    boxShadow: '5px 5px'
                }
            },
            title: props.title,
            hAxis: { title: props.hAxis.title, titleTextStyle: { italic: false, fontSize: 16, fontName:'iransans', color: (props.hAxis.color ? props.hAxis.color : '#333') } },
            vAxis: { minValue: 0 },
            // For the legend to fit, we make the chart area smaller
            chartArea: { width: '70%', height: '70%' },
            // lineWidth: 25
            }}
            // For tests
            rootProps={{ 'data-testid': '1' }}
        />
    )
}

class AdsChart extends Component {
    constructor() {
        super();
        this.state = {
            data: false,
        }
    }

    componentWillMount() {
        this.fetchData();
    }
    fetchData = () => {
        const id = this.props.match.params.id;
        getOneLoggerAdsModal(id, (data) => {
            this.setState({
            data: data,
        })});
    }

    render() {
        if(this.state.data) {
            return (
                <Row>
                    <Col span={24}>
                        <Card className={'card-with-shadow'} bordered={false}>
                            <MyChart data={[
                                ['روز','مقدار'],
                                ...this.state.data
                            ]}
                            hAxis={{title: 'امار مشاهده تبلیغ'}}
                            />
                        </Card>
                    </Col>
                </Row>
            )
        }

        return (
            <div></div>
        )
    }
}

export default AdsChart;


// WEBPACK FOOTER //
// ./src/containers/AdsModal/showCharts.js